export const AUTH_TOKEN = 'token';
export const TEST = 'TEST';
